
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LastImpressionMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LastImpressionMetricsInput"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastImpressionMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"impressions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"audience"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"medianAge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageNationalAge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medianHouseholdIncome"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageNationalHouseholdIncome"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageHouseholdSize"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"averageNationalHouseholdSize"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"campaignMetrics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startDate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CampaignBasicFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"highestReachStore"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"storeMetrics"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"retailers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RetailerBasicFields"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"stores"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StoreBasicFields"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"retailer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RetailerBasicFields"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"trends"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impressions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"plays"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1129}};
    doc.loc.source = {"body":"#import '../campaign/CampaignBasicFieldsFragment.gql'\n#import '../retailer/RetailerBasicFieldsFragment.gql'\n#import '../store/StoreBasicFieldsFragment.gql'\n\nquery LastImpressionMetrics($filter: LastImpressionMetricsInput!) {\n  lastImpressionMetrics(filter: $filter) {\n    impressions\n    plays\n    reach\n\n    audience {\n      medianAge\n      averageNationalAge\n      medianHouseholdIncome\n      averageNationalHouseholdIncome\n      averageHouseholdSize\n      averageNationalHouseholdSize\n    }\n\n    campaignMetrics {\n      company\n      endDate\n      id\n      impressions\n      name\n      reach\n      plays\n      startDate\n    }\n\n    campaigns {\n      ...CampaignBasicFields\n    }\n\n    highestReachStore {\n      city\n      id\n      reach\n      retailer\n      name\n      state\n    }\n\n    storeMetrics {\n      city\n      id\n      impressions\n      plays\n      reach\n      retailer\n      name\n      state\n    }\n\n    retailers {\n      ...RetailerBasicFields\n    }\n\n    stores {\n      ...StoreBasicFields\n\n      retailer {\n        ...RetailerBasicFields\n      }\n    }\n\n    trends {\n      day\n      impressions\n      plays\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../campaign/CampaignBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../retailer/RetailerBasicFieldsFragment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('../store/StoreBasicFieldsFragment.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["LastImpressionMetrics"] = oneQuery(doc, "LastImpressionMetrics");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/metrics/LastImpressionMetricsQuery.gql
// module id = eJe2
// module chunks = 87